import withIcon from './NewIcon';
// @ts-ignore
import IconArrowRightNav from './icon/nav/arrow-right.s.svg';

export default withIcon(IconArrowRightNav);
